import React from "react";
import {
  Table,
  TableBody,
  TablePagination,
  TableContainer,
} from "@mui/material";
import TableTop from "../TableTop/TableTop";
import { TableTopTypeEnum } from "../../../utils/enums/TableTopTypeEnum";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import AllActiveRequestsTableHead from "../TableHeads/AllRequestsTableHead";
import AllRequestsTableRow from "../TableRows/AllRequestsTableRow";

const AllRequestsTable = ({
  count,
  fetchedActiveCarRequests,
  rowsPerPage,
  setRowsPerPage,
  page,
  setPage,
  onRowSelect,
}) => {
  return (
    <div style={styles.mainContainer}>
      <TableTop count={count} variant={TableTopTypeEnum.TRANSPARENT} />
      <div style={styles.tablePaddingDiv}>
        <div style={styles.tableBorderDiv}>
          <TableContainer>
            <Table>
              <AllActiveRequestsTableHead />
              <TableBody>
                {fetchedActiveCarRequests
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((request) => {
                    return (
                      <AllRequestsTableRow
                        key={request.part_request_id}
                        carRequest={request}
                        onSelect={() => onRowSelect(request.part_request_id)}
                      />
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => {
              handleChangePage(event, newPage, setPage);
            }}
            onRowsPerPageChange={(event) => {
              handleChangeRowsPerPage(event, setRowsPerPage, setPage);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AllRequestsTable;

const styles = {
  mainContainer: {},
  tablePaddingDiv: {
    paddingInline: 30,
  },
  tableBorderDiv: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
};
